import { cva } from 'class-variance-authority'

export const trackVariants = cva(
  'rounded-full flex transition-all duration-100 items-center p-[3px] select-none pointer-events-none',
  {
    variants: {
      isDisabled: {
        true: 'opacity-50',
        false: 'opacity-100',
      },
      size: {
        small: 'h-4 w-7',
        base: 'h-5 w-9',
      },
      isChecked: {
        true: 'bg-blue-500 dark:bg-blue-500',
        false: 'bg-gray-300 dark:bg-gray-700',
      },
    },
    defaultVariants: {
      size: 'base',
      isDisabled: false,
      isChecked: false,
    },
  },
)

export const thumbVariants = cva(
  'aspect-square h-full rounded-full bg-white transition-transform duration-100',
  {
    variants: {
      size: { small: '', base: '' },
      isChecked: { true: '', false: 'translate-x-0' },
    },
    compoundVariants: [
      { size: 'small', isChecked: true, className: 'translate-x-3' },
      { size: 'base', isChecked: true, className: 'translate-x-4' },
    ],
    defaultVariants: {
      size: 'base',
      isChecked: false,
    },
  },
)
